const parallax = {
  parallaxContainers: document.querySelectorAll('.js-parallax'),
  parallaxObjects: [],
  parallaxFactor: -0.4,
  parallaxing: false,
  lastScrollPos: 0,
  init() {
    if (window.innerWidth < 768) return;
    if (!this.parallaxContainers.length) return;

    const resizeObserver = new ResizeObserver((entries) => {
      this.populate();
    });
    resizeObserver.observe(document.body);

    window.addEventListener('scroll', this.onScroll.bind(this));
  },
  populate() {
    this.parallaxObjects = [];
    this.parallaxContainers.forEach((pc) => {
      const el = pc;
      el.style = 'transform: translate3D(0, 0, 0)';
      el.offsetHeight;
      let offsetTop =
        pc.getBoundingClientRect().top + window.scrollY - window.innerHeight;
      if (pc.dataset.top == 'true') {
        offsetTop = 0;
      }
      const offsetLeft = pc.getBoundingClientRect().left;
      const containerHeight = pc.children[0].offsetHeight;
      const parallaxFactor =
        parseFloat(pc.dataset.parallax) || this.parallaxFactor;

      this.parallaxObjects.push({
        el,
        offsetTop,
        offsetLeft,
        containerHeight,
        parallaxFactor,
        noTablet: pc.dataset.tablet === 'false',
      });
    });

    this.onScroll();
  },
  onScroll() {
    if (!this.parallaxing) {
      this.parallaxing = true;
      window.requestAnimationFrame(this.parallax.bind(this));
    }
  },
  parallax() {
    const scrollPos = window.scrollY;

    if (scrollPos != this.lastScrollPos) {
      this.parallaxObjects.forEach((pi) => {
        if (window.innerWidth < 768) {
          pi.el.style.transform = '';
          return;
        }

        if (pi.noTablet && window.innerWidth < 1024) {
          pi.el.style.transform = '';
          return;
        }

        let parallaxPx = 0;
        if (pi.offsetTop === 0) {
          parallaxPx = scrollPos * pi.parallaxFactor;
        } else {
          parallaxPx =
            (scrollPos - pi.offsetTop - window.innerHeight * 0.5) *
            pi.parallaxFactor;
        }
        pi.el.style.transform = `translate3D(0, ${parallaxPx}px, 0)`;
      });

      window.requestAnimationFrame(this.parallax.bind(this));
    } else {
      this.parallaxing = false;
    }

    this.lastScrollPos = scrollPos;
  },
};
export default parallax;
